module.exports = __webpack_public_path__ + "img/02-3解决方案.98d7049b.svg";